export const mutationKeys = {
  suppliers: {
    addSelectedSuppliersToNegotiation: 'addSelectedSuppliersToNegotiation',
    removeSelectedSuppliersFromNegotiation:
      'removeSelectedSuppliersFromNegotiation',
  },
} as const;
